import React, { useEffect, useMemo, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { apiKey } from '../../utils/ktcUtils';
import axios from 'axios';

const ExamStudents = () => {
  const [rawStudents, setRawStudents] = useState([]); // flat list
  const [students, setStudents] = useState({}); // grouped
  const [loading, setLoading] = useState(true);

  // 🔎 Filters
  const today = new Date().toISOString().split('T')[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedClass, setSelectedClass] = useState('ALL');
  const [searchName, setSearchName] = useState('');

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/live-exam-students`;

    const fetchExamStudents = async () => {
      const response = await axios.get(url, {
        headers: { 'x-api-key': apiKey },
      });

      setRawStudents(response.data.report || []);
      setLoading(false);
    };

    fetchExamStudents();
  }, []);

  // 📌 Get unique classes for dropdown
  const classList = useMemo(() => {
    const classes = rawStudents.map((s) => s.class);
    return ['ALL', ...new Set(classes)];
  }, [rawStudents]);

  // 🔄 Apply filters + regroup
  useEffect(() => {
    const filtered = rawStudents.filter((std) => {
      const stdDate = std.datetime?.split('T')[0];

      return (
        (!selectedDate || stdDate === selectedDate) &&
        (selectedClass === 'ALL' || std.class === selectedClass) &&
        std.name.toLowerCase().includes(searchName.toLowerCase())
      );
    });

    const grouped = filtered.reduce((acc, item) => {
      acc[item.class] = acc[item.class] || [];
      acc[item.class].push(item);
      return acc;
    }, {});

    setStudents(grouped);
  }, [rawStudents, selectedDate, selectedClass, searchName]);

  if (loading) {
    return <h2 style={{ textAlign: 'center' }}>Loading...</h2>;
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Student List</h1>

      {/* 🔎 Filters */}
      <div style={styles.filters}>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />

        <select
          value={selectedClass}
          onChange={(e) => setSelectedClass(e.target.value)}
        >
          {classList.map((cls) => (
            <option key={cls} value={cls}>
              {cls}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Search student name..."
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
        />
      </div>

      {Object.keys(students).length === 0 && (
        <p style={{ textAlign: 'center' }}>No records found</p>
      )}

      {Object.keys(students).map((className) => (
        <div key={className} style={styles.classSection}>
          <h2 style={styles.classTitle}>Class {className}</h2>

          <div style={styles.grid}>
            {students[className].map((std) => (
              <div key={std.std_id} style={styles.card}>
                <img
                  src={`https://ecampus.uniso.edu.so/${std.image}`}
                  alt={std.name}
                  style={styles.image}
                />
                <h3>{std.name}</h3>
                <p>ID: {std.std_id}</p>
                <p>{new Date(std.datetime).toLocaleString()}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    background: '#f5f5f5',
    minHeight: '100vh',
  },
  title: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  filters: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    marginBottom: '30px',
  },
  classSection: {
    marginBottom: '40px',
  },
  classTitle: {
    marginBottom: '15px',
    color: '#333',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '20px',
  },
  card: {
    background: '#fff',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  image: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '6px',
  },
};

export default ExamStudents;
